import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 3,
  class: "user-menu absolute"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "View Admin Info", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["user-data grid items-center relative", _ctx.isSettings ? 'settings' : '']),
    ref: "user_data"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["logo", [
                _ctx.isDisabled ? '!cursor-not-allowed' : '',
                _ctx.isSettings ? 'settings' : '',
            ]]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, [
      (_ctx.logo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.logo
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createBlock(_component_IconBase, {
            key: 1,
            icon: "shopping-store"
          }))
    ], 2),
    (!_ctx.multiLocation.isActive)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["data grid grid-rows-2", _ctx.isDisabled ? '!cursor-not-allowed' : '']),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["name", _ctx.isSettings ? 'settings' : ''])
          }, _toDisplayString(_ctx.name), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["id", _ctx.isSettings ? 'settings' : ''])
          }, _toDisplayString(_ctx.id), 3)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.multiLocation.isActive)
      ? (_openBlock(), _createBlock(_component_SelectComponent, {
          key: 1,
          style: {"min-width":"12rem","margin-left":"1.5rem"},
          options: 
                _ctx.multiLocation.locationsForDropdown(
                    _ctx.router.currentRoute.value.fullPath
                )
            ,
          value: _ctx.multiLocation.selected_location_id,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.multiLocation.swapLocation($event, _ctx.router)))
        }, null, 8, ["options", "value"]))
      : _createCommentVNode("", true),
    (!_ctx.isDisabled && !_ctx.multiLocation.isActive)
      ? (_openBlock(), _createBlock(_component_IconBase, {
          key: 2,
          icon: "chevron-down",
          onClick: _ctx.toggleMenu,
          class: _normalizeClass(_ctx.isSettings ? 'text-white' : '')
        }, null, 8, ["onClick", "class"]))
      : _createCommentVNode("", true),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.userStore.user.is_admin)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "menu-item",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openAdminInfo && _ctx.openAdminInfo(...args)))
              }, [
                _createVNode(_component_IconBase, { icon: "key" }),
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menu-item",
              key: menuItem.name,
              onClick: ($event: any) => (_ctx.goTo(menuItem.name))
            }, [
              _createVNode(_component_IconBase, {
                icon: menuItem.icon
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate(menuItem.text)), 1)
            ], 8, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}